<!-- <p>tours-confirmados works! aca van los tour confirmados</p> -->

<!-- *** Tours confirmados *** -->
<ul class="nav nav-tabs">
    <li class="nav-item">
        <a class="nav-link active" [routerLink]="['/admin/tours-confirmados']" >Confirmados</a>        
    </li>
    
    <li class="nav-item pe-2">
        <a class="nav-link" aria-current="page"  [routerLink]="['/admin/tours']" >Reservados</a>  
    </li>
    
</ul>
<div class="row">
    <div class="col-12 mt-4">
        <!-- <form action="" class="login">
            <div class="form-control p-0 position-relative">
                <input type="search" class="w-100 border-secondary" placeholder="Buscar por pasajero o DNI">
                <img src="../assets/images/body/icons/search-icon.svg" class="position-absolute search-icon" alt="">
            </div>
        </form> -->
    </div>
    <!-- <div class="col-12 mt-4 d-flex">
        <div class="text-secondary rounded-pill border border-2 me-3 border-secondary btn-md btn-outline">
            Destino
        </div>
    </div> -->
</div>
<h4 class="title-bg mt-4">Tours Confirmados</h4>
<div class="row mt-4">
    <div *ngFor="let item of listPacks" class="tour-card">
        <div class="tour-wrapper">
            <ng-template
                *ngIf="item.imagen; then imgRecibida; else imgDefault">
            </ng-template>
            <ng-template #imgRecibida>
                <div class="tour-img">
                    <img src={{item.imagen}} class="img-responsive" alt="">
                </div>
            </ng-template>
                <ng-template #imgDefault>
                    <div class="tour-img">
                        <img src={{imagenDefault}} class="img-responsive" alt="">
                    </div>
                </ng-template>
            <div class="tour-content">
                <h5 class="mb-3 mt-3 text-center">{{item.paquete.nombre_paquete}}</h5>
                <a style="cursor: pointer;" (click)="verAgenciasConfirmadas(item.paquete.id)"   class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Ver info</a>
                <a style="cursor: pointer; margin-top: 5px" (click)="verAsientos(item)" class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Asientos</a>
            </div>
        </div>
    </div>
    <!-- <div class="tour-card">
        <div class="tour-wrapper">
            <div class="tour-img"><img src="../assets/images/body/tours/4.jpg" class="img-fluid" alt=""></div>
            <div class="tour-content">
                <h5 class="mb-3 mt-3 text-center">Test 1</h5>
               
                <a href="tour-agencias-reservados.php" class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Ver info</a>
            </div>
        </div>
    </div> -->
</div>

